import {createContext} from 'react';
import {LngLatBounds} from "mapbox-gl";

export interface TileCoord {
    z: number;
    x: number;
    y: number;
    bounds?: LngLatBounds
}

export const MapViewContext = createContext<{
    mapTileCoords: TileCoord[];
    setMapTileCoords: (coords: TileCoord[]) => void;
    viewportBounds: LngLatBounds;
    setViewportBounds: (viewportBounds: LngLatBounds) => void;
    hoveredStateId: string | null;
    setHoveredStateId: React.Dispatch<React.SetStateAction<string | null>>;
    mapName: string | null;
    setMapName: React.Dispatch<React.SetStateAction<string | null>>;

    selectedTagIds: string[];
    setSelectedTagIds: React.Dispatch<React.SetStateAction<string[]>>;
    selectedCategoryIds: string[];
    setSelectedCategoryIds: React.Dispatch<React.SetStateAction<string[]>>;

    searchQuery: string | null;
    setSearchQuery: React.Dispatch<React.SetStateAction<string | null>>;

    sidebarCollapsed: boolean;
    setSidebarCollapsed: React.Dispatch<React.SetStateAction<boolean>>;


}>({
    mapTileCoords: [],
    setMapTileCoords: () => {},
    viewportBounds: null,
    setViewportBounds: () => {},
    hoveredStateId: null,
    setHoveredStateId: () => {},
    mapName: null,
    setMapName: () => {},

    selectedTagIds: [],
    setSelectedTagIds: () => {},

    selectedCategoryIds: [],
    setSelectedCategoryIds: () => {},

    searchQuery: null,
    setSearchQuery: () => {},

    sidebarCollapsed: false,
    setSidebarCollapsed: () => {},
});